import { FormControl, FormHelperText, Input } from '@mui/joy';
import { Controller } from 'react-hook-form';

import { FormLabel } from 'core/elements';
import { toFieldFocusRef } from 'core/utils/fieldFocus';

import { IProps } from './NumberInput';
import NumericFormatAdapter from './NumericFormatAdapter';

const NumberInputWithControllerView = ({
  control,
  error,
  name,
  label,
  tooltip,
  required = false,
  defaultValue,
  onChange,
  placeholder = '',
  helperTexts = [],
  helperTextStyle = {},
  slotProps,
  disabled = false,
  size,
  wrapperStyle = {},
  maxWidth,
  ...rest
}: IProps) => {
  const sxProps = {};
  if (maxWidth) {
    sxProps['maxWidth'] = maxWidth;
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { ref, ...field } }) => {
        return (
          <FormControl error={Boolean(error)} sx={wrapperStyle}>
            {label && (
              <FormLabel required={required} tooltip={tooltip}>
                {label}
              </FormLabel>
            )}
            <Input
              {...field}
              {...rest}
              onChange={(e: any) => {
                if (onChange) {
                  onChange(e);
                }

                field.onChange(e);
              }}
              slotProps={{
                input: {
                  component: NumericFormatAdapter,
                  ...slotProps?.input,
                  ref: toFieldFocusRef(ref),
                },
              }}
              placeholder={placeholder}
              disabled={disabled}
              size={size}
              sx={{ ...sxProps, ...rest.sx }}
            />
            {helperTexts?.map((helperText: string, index: number) => (
              <FormHelperText key={index} sx={{ fontWeight: 500, ...helperTextStyle }}>
                {helperText}
              </FormHelperText>
            ))}
          </FormControl>
        );
      }}
    />
  );
};

export default NumberInputWithControllerView;
